import { useContext, useEffect, useState } from 'react';
import Card from './components/card/Card';
import styles from './index.module.css';
import MasineForm from './components/MasineForm/MasineForm';
import useHttp from '../../../hooks/use-http';
import MuiDialog from '../../UI/MuiDialog/MuiDialog';
import DetailView from './components/DatailView/DetailView';
import { useTranslation } from 'react-i18next';
import Spinner from '../../UI/Modal/Spinner';
import toast from 'react-hot-toast';
import { handleErrorMessage } from '../../../../shared/api/handleErrorMessage';
import Delovi from './components/Delovi';
import SearchForm from './components/SearchForm/SearchForm';
import { TabContext } from '../../../Context/TabContext';

const PregledKlijenata = ({ novaMasina, handleNovaMasina }) => {
  const { t, i18n } = useTranslation();
  // const { addTab } = useContext(TabContext);
  const INITIAL_VALUES = {
    nazivFirme: '',
  };
  const [filterValues, setFilterValues] = useState(INITIAL_VALUES);
  const { getData: getKlijenta, isLoading: isLoadingMasine } = useHttp('');
  const [openDetalView, setOpenDetalView] = useState(false);
  const [machineDetail, setMachineDetail] = useState({});

  const [klijentiData, setKlijentiData] = useState({
    source: [],
    filtered: [],
  });
  const [machineId, setMachineId] = useState(0);
  const [ukupanBroj, setUkupanBroj] = useState({ robot: 0, alat: 0 });
  const { tabsData, activeComponent, onTabChange, addTab } =
    useContext(TabContext);
  const dataLocal = tabsData.find((item) => item.type === activeComponent);
  const localFormValues = dataLocal?.filterValues
    ? dataLocal?.filterValues
    : {};
  const localKlijentiData = dataLocal?.klijentiData
    ? dataLocal?.klijentiData
    : {};

  // useEffect(() => {
  //   console.log(klijentiData);
  // }, [klijentiData]);

  useEffect(() => {
    const tab = {
      type: 1070,
      title: 'Pregled klijenata',
      icon: 'fas fa-users',
      filterValues: filterValues,
      klijentiData: klijentiData,
    };
    onTabChange(tab);
  }, [filterValues, klijentiData]);
  useEffect(() => {
    if (Object.keys(localFormValues).length > 0) {
      setFilterValues({
        ...localFormValues,
      });
    }
    if (Object.keys(localKlijentiData).length > 0) {
      console.log(localKlijentiData);
      setKlijentiData({
        ...localKlijentiData,
      });
    }
  }, []);

  useEffect(() => {
    if (novaMasina) {
      setOpenDialog(true);
      setMachineId(0);
    }
    handleNovaMasina(false);
  }, [novaMasina]);
  const vratiMasine = async () => {
    const config = {
      url: 'Kupci/vrati_kupce',
    };
    const response = await getKlijenta(config);

    if (response.length > 0) {
      if (Object.keys(localKlijentiData).length === 0) {
        setKlijentiData({ source: response, filtered: response });
      }

      setUkupanBroj({
        robot: response[0].ukupanBrojRobota,
        alat: response[0].ukupaBrojAlata,
      });
    }
  };
  useEffect(() => {
    vratiMasine();
  }, []);

  const handleOpenDetalView = (item) => {
    console.log(item);
    const tab = {
      title: 'Oprema',
      icon: 'fas fa-cogs',
      type: 68,
      data: { idKlijenta: item.id },
    };
    addTab(tab);
  };

  return (
    <>
      {isLoadingMasine && <Spinner />}
      <div>
        <div className={styles.searchContainer}>
          <div
            style={{
              display: 'flex',
              flexWrap: 'wrap',
              alignContent: 'center',
              padding: '10px',
            }}
          >
            <span>
              {`${t('totalNubmerOfRobots')}`}: {ukupanBroj.robot}
            </span>
          </div>
          <div
            style={{
              display: 'flex',
              flexWrap: 'wrap',
              alignContent: 'center',
              padding: '10px',
            }}
          >
            <span>
              {`${t('totalNubmerOfMolds')}`}: {ukupanBroj.alat}
            </span>
          </div>
          <SearchForm
            setKlijentiData={setKlijentiData}
            klijentiData={klijentiData}
            filterValues={filterValues}
            setFilterValues={setFilterValues}
          />
        </div>
        <div className={styles.cardContainer}>
          {klijentiData.filtered.map((klijent) => (
            <Card
              key={klijent.id}
              klijent={klijent}
              handleOpenDetalView={() =>
                handleOpenDetalView({ ...klijent, tipPregled: 'detalji' })
              }
            />
          ))}
        </div>
      </div>

      <MuiDialog
        maxWidth="xl"
        open={openDetalView}
        title={t('detalView')}
        content={<DetailView machineDetail={machineDetail} />}
        handleClose={() => setOpenDetalView(false)}
        deniedText="ZATVORI"
      />
    </>
  );
};

export default PregledKlijenata;
